import React, { Component } from 'react';

import MediaQuery from 'react-responsive';

import { MdWarning as LateIcon } from 'react-icons/md';
import { MdAvTimer as PastDueIcon } from 'react-icons/md';
import { MdPriorityHigh as EmergencyIcon } from 'react-icons/md';
import { MdFiberNew as NewIcon } from 'react-icons/md';

import { maintenanceColors } from 'helpers/ColorHelper';

import { PieChartWithMiddleLabel, DashboardKPI } from 'components/shared/DashboardComponents';

import moment from 'moment';

const colorMapper = {
  broken: maintenanceColors.PENDING,
  offline: maintenanceColors.OPEN,
  replace: maintenanceColors.SCHEDULED,
  wo_outstanding: maintenanceColors.ON_THE_WAY,
  service_due: maintenanceColors.FIXING,
  healthy: maintenanceColors.CLOSED,
  inactive: maintenanceColors.INACTIVE,
};

export default class AssetDashboard extends Component {
  render() {
    const openMaintenanceAssets = this.props.data;

    return (
      <div style={{ maxWidth: '1000px', margin: 'auto' }}>
        <div className="col-sm-4" style={{ padding: 0, textAlign: 'center' }}>
          <PieChartWithMiddleLabel
            onClickAction={this.props.onClickAction}
            pieChartValues={this.props.pieChartValues}
            colorMapper={colorMapper}
            inactiveHeader="total assets"
            inactiveSubheader={this.props.data.length}
          />
        </div>

        <MediaQuery query="(min-device-width: 700px)">
          <div className="col-sm-8" style={{ padding: 0 }}>
            <div className="row" style={{ margin: '20px 0' }}>
              <div className="col-xs-6" style={{ textAlign: 'center' }}>
                <DashboardKPI
                  icon={<PastDueIcon size={30} style={{ marginTop: '12px', color: 'white' }} />}
                  headerValue={
                    openMaintenanceAssets.filter((asset) =>
                      moment().subtract(48, 'hours').isAfter(moment(asset.request_date))
                    ).length
                  }
                  subHeaderValue="outstanding work orders"
                  highlightValue="48hours"
                  onClickAction={() => this.props.onClickAction('48hours')}
                  filterValue={this.props.filterValue}
                />
              </div>
              <div className="col-xs-6" style={{ textAlign: 'center' }}>
                <DashboardKPI
                  icon={<LateIcon size={30} style={{ marginTop: '12px', color: 'white' }} />}
                  headerValue={
                    openMaintenanceAssets.filter((asset) => asset.status.toLowerCase() === 'broken')
                      .length
                  }
                  subHeaderValue="unplanned downtime"
                  highlightValue="broken"
                  onClickAction={() => this.props.onClickAction('broken')}
                  filterValue={this.props.filterValue}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6" style={{ textAlign: 'center' }}>
                <DashboardKPI
                  icon={<NewIcon size={30} style={{ marginTop: '12px', color: 'white' }} />}
                  headerValue={
                    openMaintenanceAssets.filter(
                      (ticket) => ticket.status.toLowerCase() === 'service due'
                    ).length
                  }
                  subHeaderValue="upcoming service due"
                  highlightValue="service due"
                  onClickAction={() => this.props.onClickAction('service due')}
                  filterValue={this.props.filterValue}
                />
              </div>
              <div className="col-xs-6" style={{ textAlign: 'center' }}>
                <DashboardKPI
                  icon={<EmergencyIcon size={30} style={{ marginTop: '12px', color: 'white' }} />}
                  headerValue={
                    openMaintenanceAssets.filter((asset) => asset.status === 'Replace').length
                  }
                  subHeaderValue="needs replacement"
                  highlightValue="replace"
                  onClickAction={() => this.props.onClickAction('replace')}
                  filterValue={this.props.filterValue}
                />
              </div>
            </div>
          </div>
        </MediaQuery>
      </div>
    );
  }
}
